module.exports = __webpack_public_path__ + "img/588x310-03.11e53935.png";